type ConnectivityListener = (isOnline: boolean) => void;

const isWeb = typeof window !== "undefined" && typeof window.addEventListener === "function";
const listeners = new Set<ConnectivityListener>();
let online = isWeb ? navigator.onLine : true;

function handleOnline() {
  if (!online) {
    online = true;
    for (const fn of listeners) fn(true);
  }
}

function handleOffline() {
  if (online) {
    online = false;
    for (const fn of listeners) fn(false);
  }
}

let initialized = false;

function init() {
  if (initialized) return;
  initialized = true;
  if (isWeb) {
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
  }
}

export function getOnlineStatus(): boolean {
  return online;
}

export function subscribeToConnectivity(listener: ConnectivityListener): () => void {
  init();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function setOnlineStatus(value: boolean): void {
  if (value !== online) {
    online = value;
    for (const fn of listeners) fn(value);
  }
}
